<template>
  <div class="btn-group">
    <button type="button" :key="val+key"
            v-for="(val, key) in values"
            @click="changeSelectVal(val)"
            :class="['btn', { 'btn-primary': selected === val, 'btn-default': selected !== val }]"
    >{{ val }}
    </button>
  </div>
</template>

<script>
export default {
  name: "ToggleButton",
  props: ['values', 'default'],
  data() {
    return {
      selected: ''
    }
  },
  mounted: function () {
    this.selected = this.default;
  },
  methods: {
    changeSelectVal: function (val) {
      this.selected = val;
      this.$emit("click", val);
    }
  }
}
</script>

<style lang="scss" scoped>
@use "src/assets/styles/variables.scss" as *;


.heading {
  h1 {
    color: #fff;
    font-size: 4rem;
    font-weight: 900;
    margin: 0 0 5px 0;
    background: -webkit-linear-gradient(#fff, #999);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-align: center;
  }

  h4 {
    color: lighten(#5c3d86, 30%);
    font-size: 24px;
    font-weight: 400;
    text-align: center;
    margin: 0 0 35px 0;
  }
}

.options {
  @media (min-width: 992px) {
    padding-top: 80px;
  }
}

.btn {
  outline: none !important;
}

.btn.btn-primary {
  background-color: #00b6ed;
  border-color: #00b6ed;
  color: #fff;
  outline: none;

  &:hover {
    background-color: darken(#00b6ed, 10%);
    border-color: darken(#00b6ed, 10%);
  }

  &:active, &:focus {
    background-color: lighten(#00b6ed, 5%);
    border-color: lighten(#00b6ed, 5%);
  }
}

.btn.btn-default {
  &:hover {
    background-color: darken(#00b6ed, 10%);
    border-color: darken(#00b6ed, 10%);
    color: #fff;
  }

  &:active, &:focus {
    background-color: lighten(#00b6ed, 5%);
    border-color: lighten(#00b6ed, 5%);
    color: #fff;
  }
}

.btn {
  width: 100px;
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
}
.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group>.btn:first-child {
  margin-left: 0;
}
.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle) {
  border-radius: 0;
}
.btn-group{
  width: 200px;
  margin: auto;
}
.btn-group .btn+.btn, .btn-group .btn+.btn-group, .btn-group .btn-group+.btn, .btn-group .btn-group+.btn-group {
  margin-left: -1
  px
;
}
.btn.btn-primary {
  background-color: #00b6ed;
  border-color: #00b6ed;
  outline: none;
}
.btn-primary {
  color: #fff;
}
.btn-group>.btn:last-child:not(:first-child), .btn-group>.dropdown-toggle:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-default {
  color: #333;
  background-color: #fff;
  border-color: #ccc;
}
</style>